import { IconProps } from '@chakra-ui/react';
import { memo, useMemo } from 'react';
import { IconBox } from '~/components/IconBox';
import {
  InstagramNoBorderIcon,
  TiktokNoBorderIcon,
  YoutubeNoBorderIcon,
} from '~/components/icons';
import { SOCIAL_PLATFORMS } from '~/constants';

interface Props extends IconProps {
  platform: SOCIAL_PLATFORMS;
  trackId?: string;
}

export const PlatformIcon: React.FC<Props> = memo(
  ({ platform, trackId, ...props }) => {
    const PlatformIconComponent = useMemo(() => {
      return {
        [SOCIAL_PLATFORMS.instagram]: InstagramNoBorderIcon,
        [SOCIAL_PLATFORMS.tiktok]: TiktokNoBorderIcon,
        [SOCIAL_PLATFORMS.youtube]: YoutubeNoBorderIcon,
      }[platform];
    }, [platform]);

    return (
      <IconBox
        backgroundColor="primary.400"
        borderRadius={4}
        boxSize={4}
        track-id={trackId}
        icon={
          <PlatformIconComponent boxSize="0.6rem" color="white" {...props} />
        }
      />
    );
  },
);
